


















import {
  Vue,
  Component,
  ComponentConfig,
  ComponentStyle,
  ComponentStyleDefinition,
  ModelProp,
  Advisor,
  InjectComponent,
  VueComponent,
  QAFlowStepsNavigation,
  Provide,
} from "@zoovu/runner-browser-api";
import {
  ColorsConfiguration,
  FontsConfiguration,
  TopProductConfiguration,
  CustomCSSConfiguration,
  PdfConfiguration,
} from "@zoovu/runner-web-design-base";
import { CustomizedStandardTextsConfiguration } from "../configuration/customized-standard-texts-configuration";

@Component({
  name: "AdvisorView",
})
export default class AdvisorViewExtended extends Vue {
  @InjectComponent("QuestionnaireView")
  questionnaireView: VueComponent;

  @InjectComponent("ComparisonView")
  comparisonView: VueComponent;

  @InjectComponent("ResultsSectionView")
  resultsSectionView: VueComponent;

  @InjectComponent("PdfContentView")
  pdfContentView: VueComponent;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @ComponentConfig(ColorsConfiguration)
  colors: ColorsConfiguration;

  @ComponentConfig(FontsConfiguration)
  fonts: FontsConfiguration;

  @ComponentConfig(CustomizedStandardTextsConfiguration)
  standardTexts: CustomizedStandardTextsConfiguration;

  @ComponentConfig(TopProductConfiguration)
  topProductConfiguration: TopProductConfiguration;

  @ComponentConfig(CustomCSSConfiguration)
  customCSSConfiguration: CustomCSSConfiguration;

  @ComponentConfig(PdfConfiguration)
  pdfConfiguration: PdfConfiguration;

  @ModelProp()
  advisor: Advisor;

  usingMouse = true;

  mouseDownEventListener;

  keyDownEventListener;

  pdfMarkupIsReady = false;

  get isPdfMarkupShown(): boolean {
    return this.pdfConfiguration.enabled && this.pdfMarkupIsReady;
  }

  // temporary: AdvisorLocalizationSettingsDefinition is not exported by RBA unfortunately
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  @Provide()
  get localizationSettings() {
    return this.advisor.localizationSettings;
  }

  get navigation(): QAFlowStepsNavigation {
    return this.advisor.flowStepsNavigation;
  }

  beforeMount(): void {
    this.mouseDownEventListener = document.body.addEventListener("mousedown", () => {
      this.usingMouse = true;
    });
    this.keyDownEventListener = document.body.addEventListener("keydown", () => {
      this.usingMouse = false;
    });
  }

  mounted(): void {
    this.$root.$on("toggle-pdf-markup", (status: boolean) => {
      this.pdfMarkupIsReady = status;
    });
  }

  beforeDestroy(): void {
    document.body.removeEventListener("mousedown", this.mouseDownEventListener);
    document.body.removeEventListener("keydown", this.keyDownEventListener);
  }
}
